export default __webpack_public_path__ + "static/media/img4.dee54220.png";